import React from 'react';
// material
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
// containers
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';

function ProcessingPlantsForm(props) {
    const { t } = useTranslation();
    return (
        <Dialog
            fullWidth
            onClose={props.toggleForm}
            aria-labelledby="simple-dialog-title"
            open={props.isOpen}>
            <DialogTitle>
                {props.edit ? t('Edit') : t('Create')}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item sm={6} xs={12}>
                        <TextField
                            value={props.controls.name}
                            onChange={props.changeControls}
                            fullWidth
                            id="name"
                            label={t('Name')}
                            error={props.invalidControls.name}
                            helperText={props.invalidControls.name && t('Name required')}
                            inputProps={{ maxLength: 50 }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.toggleForm} color="primary">
                    {t('CANCEL')}
                </Button>
                <ButtonWithLoader onClick={props.submit} autoFocus buttonId="create-edit-processing-plant">
                    {props.edit ? t('Edit') : t('Add')}
                </ButtonWithLoader>
            </DialogActions>
        </Dialog>
    );
}

export default ProcessingPlantsForm;